<template>
  <select-widget
    v-bind="$attrs"
    v-on="$listeners"
    :multiple="multiple"
  />
</template>

<script>

import SelectWidget from './SelectWidget'

export default {
  name: 'filter-multiselect-widget',
  components: { SelectWidget },

  props: {
    multiple: { type: Boolean, default: true },
  },
}

</script>
